import { proxy } from 'valtio';

const state = proxy({
    intro: true,
    color: '#efbd48',
    backgroundColor: '#413720',
    updatee: null,
    extrusion: null,
    orbitControlActivation: false
});

export default state;